import React from "react";
import {Helmet} from "react-helmet-async";
import {Container} from "react-bootstrap";
import AdminUserTableHandler from "../../components/admin/AdminUserTableHandler";

// /admin/user_management component which shows the users
const Users = () => (
    <React.Fragment>
        <Helmet title="Gebruikers"/>
        <Container fluid className="p-0">
            <AdminUserTableHandler/>
        </Container>
    </React.Fragment>
);

export default Users;
